const CREATE = 'create'
const EDIT = 'edit'
const GET = 'get'
const DELETE = 'delete'
const EXPORT_AS_PDF = 'export_as_pdf'


export default{ CREATE, EDIT, GET, DELETE, EXPORT_AS_PDF }